// src/socketClient.js
import { io } from "socket.io-client";
import { getSocketUrl } from "./Config";

const socket = io(getSocketUrl() || "http://localhost:8800", {
  autoConnect: !!getSocketUrl(),
  transports: ["websocket"],
  reconnectionAttempts: 5,
  timeout: 10000,
});

socket.emit("join_plan", "Basic"); // or "Basic", "Premium","Standard"

export default socket;
